<template>
  <div>
    <div>
      <Wp_image :url="getImage()" :radius="0"/>
      <div class="text-area">
        <div class="title" v-html="linkContent"></div>
        <div>
          （推广链接已转链:{{ $common.getUsername() }})
        </div>
        <div v-if="actData.advantage">
          更新时间:{{ $common.dateFmt('yyyy.MM.dd', new Date(actData.updateTime)) }}
        </div>
      </div>
      <div class="text-area">
        <van-button
            size="small"
            type="danger"
            style="width:100%"
            v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'), '\n')"
            v-clipboard:success="onCopySuccess"
            v-clipboard:error="onCopyError"
        >复制文案
        </van-button>
      </div>
      <div class="text-area">
        <van-button
            size="small"
            type="info"
            style="width:100%"
            @click="openUrl"
        >进入活动
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Wp_image from '../custom/Wp_image'
import union_utils from '../../js/union_utils'

export default {
  components: { Wp_image },
  props: {
    actData: {}
  },
  data () {
    return {
      actUrl: '',
      linkContent: '',
    }
  },
  watch: {
    actData: {
      handler (newV, oldV) {
        this.$union_utils.getActivityUnionLink(newV, shortUrl => {
          this.actUrl = shortUrl
          this.makeLinkContent(newV)
        })
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    getImage () {
      if (this.actData) {
        return this.$union_utils.getActivityImage(this.actData.imgList, '350*350')
      }
    },
    getActTime () {
      if (this.actData) {
        let endTime = new Date(this.actData.endTime)
        let startTime = new Date(this.actData.startTime)
        return this.$common.dateFmt('yyyy.MM.dd', startTime) + '-' + this.$common.dateFmt('yyyy.MM.dd', endTime)
      }
    },
    makeLinkContent (actData) {
      if (actData) {
        this.linkContent = actData.title + '<br/>'
        if( actData.advantage) {
          this.linkContent = this.linkContent + actData.advantage + '<br/>'
          this.linkContent = this.linkContent + '活动时间:' + this.getActTime() + '<br/>'
        }
        this.linkContent = this.linkContent + '活动链接:' + this.actUrl + ''
      }
    },
    getUnionUrl (actData) {
      if (actData) {
        let _positionId = this.$common.getPid()
        let _data = {
          app_key: this.$common.getAppKeyInfo('70637').app_key,
          app_secret: this.$common.getAppKeyInfo('70637').app_secret,
          materialId: actData.urlM,
          subUnionId: '',
          positionId: _positionId, //推广位ID
          chainType: 2,
        }
        this.$getUnionLink(_data, res => {
          if (res.code === 200) {
            this.actUrl = res.data.shortURL
          }
        })
      }
    },
    openUrl () {
      window.location.href = this.actUrl
    },
    onCopySuccess () {
      this.$toast.success({
        message: '文案复制成功'
      })
    },

    onCopyError () {
      this.$toast.fail({
        message: '文案复制失败，请尝试手动复制文案'
      })
    }
  }
}
</script>
<style>
.text-area {
  padding: 10px;
}

.title {
  font-size: 20px;
  font-weight: bold;
}

.subTitle {
  font-size: 18px;
  font-weight: bold;
}
</style>